import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerServiceService } from "src/app/customer/customer-service.service";
import { AdminService } from "../admin.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-add-truck-type",
  templateUrl: "./admin-add-truck-type.component.html",
  styleUrls: ["./admin-add-truck-type.component.css"],
})
export class AdminAddTruckTypeComponent implements OnInit {
  truckTypeForm!: FormGroup;
  token: any;
  CategoryList: any;
  file: any;
  truckImage: any;
  editTruckType: boolean = false;
  truckImg: boolean = false;
  uploadImg: boolean = true;
  crossImg: boolean = false;
  typeImageloading: boolean = false;
  perPage: any = 100;
  startPage: any = 1;
  searchEmployeeName: any = -1;
  loading: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminAddTruckTypeComponent>,
    private formBuilder: FormBuilder,
    private service: AdminService,
    private custSrv: CustomerServiceService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar
  ) {
    if (data) {
      this.truckImg = true;
      this.crossImg = true;
      this.uploadImg = false;
    }
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.truckTypeForm = this.formBuilder.group({
      truck_weight: [
        "",
        [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)],
      ],
      truck_feet: ["", [Validators.required]],
      truck_category_id: ["", Validators.compose([Validators.required])],
      truck_type_description: ["", [Validators.required]],
      truck_type_image: ["", [Validators.required]],
      minimum_amount: [null, [Validators.required]],
      spped_limit: [null, [Validators.required]],
    });

    this.GetTruckCategory();
    if (this.data !== null) {
      let Weight = this.data.truck_weight.split(" ");
      let feet = this.data.truck_feet.split(" ");
      this.truckTypeForm.patchValue(this.data);
      this.truckTypeForm.patchValue({ truck_weight: Weight[0] });
      this.truckTypeForm.patchValue({ unit: Weight[1] });
      this.truckTypeForm.patchValue({ truck_feet: feet[0] });
      this.truckImage = this.data.truck_type_image;
      this.editTruckType = true;
    }
  }

  public GetTruckCategory() {
    this.service
      .GetCategory(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.startPage,
        true
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.CategoryList = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public close() {
    this.matdialogref.close();
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.typeImageloading = true;
    this.service.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.truckImage = response.body.image_link;
          this.uploadImg = false;
          this.truckImg = true;
          this.crossImg = true;
          this.typeImageloading = false;
          this.truckTypeForm.controls["truck_type_image"].setValue(
            this.truckImage
          );
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public onSubmitType(event: any) {
    // if (this.truckTypeForm.invalid) {
    //   this.truckTypeForm.markAllAsTouched();
    //   return;
    // }
    if (!this.truckTypeForm.valid || this.loading) {
      return; // 🚀 Prevent clicks if already loading
    }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly
    if (this.truckTypeForm.value.truck_type_image == "") {
      this.snackBar.open("Please upload truck image", "Fail", {
        duration: 3000,
      });
      return;
    } else {
      // Parse the truck_weight to a number and format to two decimal places
      let truckWeight = parseFloat(this.truckTypeForm.value.truck_weight);
      if (!isNaN(truckWeight)) {
        truckWeight = parseFloat(truckWeight.toFixed(2));
      }

      // Patch the formatted truck_weight value
      this.truckTypeForm.patchValue({
        truck_weight: truckWeight + " MT"
      });
      this.truckTypeForm.patchValue({
        truck_feet: this.truckTypeForm.value.truck_feet + " FT",
      });

      // Uncomment and update the service call as needed
      this.service.AddTruckType(this.truckTypeForm.value, this.token).subscribe(
        (response: any) => {
          if (response.status === 201) {
            this.snackBar.open("Truck type added successfully", "Success", {
              duration: 5000,
            });
            this.close();
          }
          setTimeout(() => {
            this.loading = false; // ✅ Enable button after response
            (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
          }, 500);
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    }
  }

  public onEditType(event: any) {
    // if (!this.truckTypeForm.valid) {
    //   this.truckTypeForm.markAllAsTouched();
    //   return;
    // }
    if (!this.truckTypeForm.valid || this.loading) {
      return; // 🚀 Prevent clicks if already loading
    }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly

    if (this.truckTypeForm.value.truck_type_image == "") {
      this.snackBar.open("Please upload truck image", "Fail", {
        duration: 3000,
      });
      return;
    } else {
      this.truckTypeForm.patchValue({
        truck_weight:this.truckTypeForm.value.truck_weight + " MT" 
      });
      this.truckTypeForm.patchValue({
        truck_feet: this.truckTypeForm.value.truck_feet + " FT",
      });
      this.service
        .EditTruckType(this.truckTypeForm.value, this.token, this.data._id)
        .subscribe(
          (response: any) => {
            if (response.status === 200 || response.status === 201) {
              this.snackBar.open("Truck type edited successfully", "Success", {
                duration: 5000,
              });
              this.close();
            }
            setTimeout(() => {
              this.loading = false; // ✅ Enable button after response
              (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
            }, 500);
          },
          (error) => {
            if (error.error.message === "jwt malformed") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "jwt expired") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "invalid signature") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        );
    }
  }
  removeImg() {
    this.truckImg = false;
    this.crossImg = false;
    this.uploadImg = true;
    this.truckTypeForm.patchValue({
      truck_type_image: "",
    });
  }

  disableScroll(event: WheelEvent): void {
    event.preventDefault();
  }
}
